.bc{position:absolute;}